import { render } from "./CmsView.vue?vue&type=template&id=7bca65a4&scoped=true"
import script from "./CmsView.vue?vue&type=script&lang=js"
export * from "./CmsView.vue?vue&type=script&lang=js"

import "./CmsView.vue?vue&type=style&index=0&id=7bca65a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bca65a4"]])

export default __exports__